// extracted by mini-css-extract-plugin
export default {"EventCard":"EventCard_EventCard__nDA0g"};